import {
  Component,
  ViewEncapsulation,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BnplService } from '../../shared/services/bnpl.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import {
  faCheckCircle,
  faTimesCircle,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import { NavigationExtras, Router } from '@angular/router';
import { DocumentsRequest } from '../../shared/models/documents-request.model';
import { Document } from '../../shared/models/documents.model';
import { SignDocument } from '../../shared/models/sign-document.model';
import Swal from 'sweetalert2';
import { Payment } from '../../shared/models/payment.model';
import { OtherOtp } from '../../shared/models/other-otp.model';
import { IdentityvalidationService } from '../../shared/services/identityvalidation.service';
import { DataInformation } from '../../shared/models/data-information.model';
import { FormComponent } from 'src/app/core/components/form/form.component';
import { MatDialog } from '@angular/material/dialog';
import {
  IAutoDebitAccount,
  IGetAutoDebitAccountBody,
  IPostAutoDebitAccountBody,
} from '../../shared/models/automaticDebits.model';
import { AutomaticDebitService } from '../../shared/services/automatic-debit.service';
import { error } from 'logrocket';
import { JuradValidationService } from '../../shared/services/jurad-validation.service';
import { IInitJuradBody } from '../../shared/models/jurad.model';
import { maskText } from '../../shared/utils/maskText';

@Component({
  selector: 'app-sign-documents',
  templateUrl: './sign-documents.component.html',
  styleUrls: ['./sign-documents.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SignDocumentsComponent implements OnInit {
  @ViewChild(FormComponent) appFormComponent!: FormComponent;
  public showFormOtp: boolean = false;
  public showDialog: boolean = false;
  public controls$: Observable<ControlBase<any>[]>;
  public mostrarNuevoCodigo: boolean = false;
  public mostrarError: boolean = false;
  public timesCircle = faTimesCircle;
  public circleInfo = faCircleInfo;
  public checkCircle = faCheckCircle;
  public documents: Document[] = [];
  public dataInformation: DataInformation;
  public amountFinance: number = 0;
  modalRef?: BsModalRef;
  channel: string = localStorage.getItem('C') || '';
  navigationExtras: NavigationExtras = {};

  banksExperian: any = [];
  listBanks: any = [];
  text1: string = `
  <div style="max-height: 200px; overflow-y: auto; color: white; text-align: justify;">
  <p style="padding: 0.5rem">El monto del cupo crédito rotativo será informado al DEUDOR al momento de su aprobación, el cual podrá utilizar en los comercios suscritos y aprobados a través de DUVERA KAPITAL (APPROBE).
  DEUDOR podrá realizar utilizaciones con cargo a dicho cupo y al plazo que escoja según las condiciones de cada comercio, sin exceder doce (12) meses.</p>
  
  <p style="padding: 0.5rem">No obstante, lo anterior, DUVERA KAPITAL (APPROBE) podrá en cualquier tiempo, de manera permanente o transitoria, conforme a sus políticas de riesgo, suprimir, unificar o disminuir el cupo de crédito asignado al DEUDOR, de acuerdo con (i) el comportamiento del mercado, (ii) la capacidad económica de El DEUDOR, (iii) la disponibilidad de tesorería, (iv) las condiciones del cupo y (v) cualquier otra razón que pueda afectar la capacidad de pago de El DEUDOR.</p>
  
  <p style="padding: 0.5rem">En caso tal que el DEUDOR presente mora en el cupo crédito rotativo o cualquier otro producto con DUVERA KAPITAL (APPROBE) superior a 15 días, el cupo crédito rotativo queda bloqueado temporalmente, impidiendo así su utilización, hasta tanto el DEUDOR se ponga al día en sus obligaciones. Si la mora en el cupo de crédito rotativo o cualquier producto de crédito con Approbe supera los 31 días, el cupo crédito rotativo quedará bloqueado de forma permanente.</p>
  
  <p style="padding: 0.5rem">Para ampliación de esta información remitirse a “Contrato crédito Rotativo” adjunto.</p>
</div>
  `;

  text2: string = `
  <div style="max-height: 200px; overflow-y: auto; color: white; text-align: justify;">
  <p style="padding: 0.5rem">El seguro de vida deudores respaldado por Seguros SURA garantiza el pago del monto de tu
    deuda
    que no hayas alcanzado a pagar a Appobe en caso de fallecimiento o incapacidad. </p>
  <p style="padding: 0.5rem">También te cubre el pago máximo de 3 cuotas de crédito sin que supere COP $1.700.000
    el valor total de tus cuotas, si tienes contrato de trabajo y eres despedido sin justa causa;
    o si eres un trabajador independiente y tienes una incapacidad temporal superior a 14 días.
    En este último caso, el pago dependerá de los días de incapacidad que tuviste.</p>
  <p style="padding: 0.5rem">Conoce más acerca de las condiciones y exclusiones que le aplican a cada cobertura aquí.
  </p>

</div>
  `;

  automaticDebit: boolean = false;
  autoDebitAccountSelected: IPostAutoDebitAccountBody | null = null;
  autoDebitAccountSelectedImage: string = '';
  getAutomaticDebit: boolean = false;
  maskText = maskText;

  constructor(
    private readonly bnplService: BnplService,
    private readonly router: Router,
    private readonly modalService: BsModalService,
    private readonly validationStrategyService: IdentityvalidationService,
    private readonly dialog: MatDialog,
    private readonly automaticDebitService: AutomaticDebitService,
    private juradValidationService: JuradValidationService
  ) {
    this.dataInformation = this.bnplService.personalInformation;
    this.amountFinance = this.bnplService.creditEmit.amountFinance;
    this.controls$ = this.bnplService.getOtpControls();
  }

  ngOnInit(): void {
    let data: any;
    if (this.channel == 'cupo') {
      data = {
        actionStrategyPattern: 'GENERATE_DOCUMENTS',
        id:
          this.bnplService.personalInformation.id ||
          localStorage.getItem('id') ||
          '',
        channel: this.channel,
      };
    } else {
      data = {
        actionStrategyPattern: 'GENERATE_DOCUMENTS',
        id:
          this.bnplService.personalInformation.id ||
          localStorage.getItem('id') ||
          '',
      };
    }
    this.bnplService.getDocuments(data).subscribe((resp: any) => {
      this.documents = resp;
      Swal.close();

      this.navigationExtras = { state: resp };
      if (resp != undefined && resp.showMessage == 1) {
        this.appFormComponent.resetForm();
        Swal.close();
        this.bnplService.openSnack(resp);
      }

      if (resp != undefined && resp.showMessage == 2) {
        Swal.close();
        this.router.navigate(['/await-alert', 'error'], this.navigationExtras);
      }

      if (resp != undefined && resp.errorMessage) {
        this.router.navigate(['/await-alert', 'error-connection']);
      }
    });
    this.handleGetAutomaticDebit();
    this.handleValidationJurad();
  }

  getConfirmOtp({ otp }: any) {
    this.bnplService.alertWait();
    const contratoMutuo = this.documents.find(
      (document) => document.name === '_Contrato_de_mutuo'
    );
    if (contratoMutuo) {
      const signDocument: SignDocument = {
        actionStrategyPattern: 'VALIDATE_OTP_SIGNATURE_DOCUMENTS_CUPOS',
        contratoMutuo: contratoMutuo,
        id:
          this.bnplService.personalInformation.id ||
          localStorage.getItem('id') ||
          '',
        otp,
      };
      this.bnplService
        .signDocument(signDocument)
        .subscribe((resp: Payment | any) => {
          this.navigationExtras = { state: resp };
          if (resp != undefined && resp.showMessage == 1) {
            this.appFormComponent.resetForm();
            Swal.close();
            this.bnplService.openSnack(resp);
          }

          if (resp != undefined && resp.showMessage == 2) {
            Swal.close();
            this.router.navigate(
              ['/await-alert', 'error'],
              this.navigationExtras
            );
          }

          if (resp != undefined && resp.errorMessage) {
            this.router.navigate(['/await-alert', 'error-connection']);
          }

          if (resp.validationStrategy === 'SAVE_CUPO') {
            const emailData: any = {
              actionStrategyPattern: 'EMAIL_CUPOS',
              id:
                this.bnplService.personalInformation.id ||
                localStorage.getItem('id') ||
                '',
            };
            this.bnplService.emailPeticon(emailData).subscribe((res) => {});
            this.bnplService.payment = resp;
            this.router.navigate(['await-alert', 'felicidades']);
          }

          if (resp.validationStrategy == 'OK') {
            const data = {
              actionStrategyPattern: 'CONSUME_CUPOS',
              id:
                this.bnplService.personalInformation.id ||
                localStorage.getItem('id'),
              ammount:
                this.bnplService.personalInformation.ammount ||
                localStorage.getItem('ammount'),
              cupo: this.bnplService.creditEmit.amountFinance,
            };
            this.bnplService.getCreditCupo(data).subscribe((resp: any) => {
              this.navigationExtras = { state: resp };

              if (resp != undefined && resp.showMessage == 1) {
                this.appFormComponent.resetForm();
                Swal.close();
                this.bnplService.openSnack(resp);
              }

              if (resp != undefined && resp.showMessage == 2) {
                Swal.close();
                this.router.navigate(
                  ['/await-alert', 'error'],
                  this.navigationExtras
                );
              }

              if (resp.validationStrategy == 'OK') {
                this.bnplService.payment = resp;
                this.router.navigate(['/payment']);
              }
            });
          }
        });
    }
  }

  enviarNuevoOtp() {
    let data: OtherOtp = {
      id:
        this.bnplService.personalInformation.id ||
        localStorage.getItem('id') ||
        '',
      actionStrategyPattern: 'RESEND_OTP',
    };
    this.validationStrategyService.getOtherOtp(data).subscribe((resp: any) => {
      this.mostrarError = false;
      if (resp.validationStrategy === 'SEND_OTP') {
        this.mostrarNuevoCodigo = true;
        setTimeout(() => {
          this.mostrarNuevoCodigo = false;
        }, 5000);
      }
    });
  }

  abrirDocumento(modalDocumento: TemplateRef<any>, document: any) {
    this.modalRef = this.modalService.show(modalDocumento, {
      class: 'modal-dialog modal-xl',
      initialState: {
        documento: document,
      },
    });
  }

  openTermConditions(type: number) {
    let message: string = '';
    if (type == 1) {
      message = this.text1;
    } else if (type == 2) {
      message = this.text2;
    }
    Swal.fire({
      html: message,
      showConfirmButton: true,
      customClass: {
        popup: 'custom-popup',
      },
    });
  }

  handleAutomaticDebit() {
    if (this.autoDebitAccountSelected) {
      this.autoDebitAccountSelected = null;
      this.autoDebitAccountSelectedImage = '';
      this.getAutomaticDebit = false;
    } else {
      this.automaticDebit = !this.automaticDebit;
    }
  }

  handleModifyAutomaticDebit() {
    this.automaticDebit = true;
    this.autoDebitAccountSelected = null;
    this.autoDebitAccountSelectedImage = '';
    this.getAutomaticDebit = false;
  }

  handleGetAutomaticDebit() {
    const data: IGetAutoDebitAccountBody = {
      personId: this.bnplService.stepsInformation.firstStep.numeroDocumento,
    };
    this.automaticDebitService.getAutoDebitAccount(data).subscribe({
      next: (response) => {
        if (response.cuentas) {
          const account: IAutoDebitAccount[] = response.cuentas
            .filter((account) => account.status)
            .map((account) => account);
          this.autoDebitAccountSelected = {
            personId:
              this.bnplService.stepsInformation.firstStep.numeroDocumento,
            bankName: account[0].bankName,
            bankCode: account[0].bankCode,
            accountType: account[0].accountType,
            currency: account[0].currency,
            accountNumber: account[0].accountNumber,
          };
          this.getAutomaticDebit = true;
        }
      },
      error: (error) => {
        console.error('Error al obtener debito inscrito', error);
      },
    });
  }

  handlePostAutomaticDebit() {
    if (!this.getAutomaticDebit && this.autoDebitAccountSelected) {
      this.automaticDebitService
        .postAutoDebitAccount(this.autoDebitAccountSelected)
        .subscribe({
          next: (response) => {
            console.log('Registro de debito en proceso');
          },
          error: (error) => {
            console.error('Error al intentar registrar el debito', error);
          },
        });
    }
  }

  handleValidationJurad() {
    const secondStep = this.bnplService.stepsInformation.secondStep;
    if (secondStep.dia && secondStep.mes && secondStep.anio) {
      const body: IInitJuradBody = {
        actionStrategyPattern: 'JURAD',
        tipoIdentificacion: 1,
        tipoIdentificacionText: 'CC',
        identificacion:
          this.bnplService.stepsInformation.firstStep.numeroDocumento,
        fechaExpedicion: `${secondStep.dia}/${secondStep.mes}/${secondStep.anio}`,
      };
      this.juradValidationService.juradService(body).subscribe({
        next: (response: any) => {
          if (response.validationStrategy == 'NEGADO') {
            this.navigationExtras = { state: response };
            this.router.navigate(
              ['/await-alert', 'error'],
              this.navigationExtras
            );
          }
        },
        error: (error) => {
          console.error('No hay respuesta de jurad de momento');
        },
      });
    }
  }
}

/**
 import { DialogDruo } from 'src/app/shared/components/dialog-druo/dialog-druo.component';
import { DataExperian } from '../../shared/models/dataExperian.model';
import { DialogDruoService } from 'src/app/shared/components/service/dialog-druo.service';
  dataDruo: any = null
  checkDruo: boolean = false
    private readonly serviceDruo: DialogDruoService,
          this.checkDruo = false


if (this.bnplService.druo.exists != 'S') {
        try {
          this.documents = resp;
          this.checkDruo = true
          const dataBaNKS = {
            action: "GET_BANKS"
          }
          this.serviceDruo.getDataExperian(dataBaNKS).subscribe((res: any) => {
            this.listBanks = res.lastLowLevelResult.scanResult.items
          })
          this.getDataBanksDruo().subscribe((res: DataExperian[]) => {
            this.banksExperian = res;
            Swal.close();
          });
          
        } catch (error) {
          this.documents = resp;
          this.checkDruo = false
          Swal.close();
        }
      } else {
        Swal.close();
        this.checkDruo = false
        this.documents = resp;
      }


          try {
            if (this.bnplService.druo.exists != 'S') {
              this.saveAccountDruo().subscribe((res: any) => {
                if (res == "SUCCESS") {
                  this.bnplService.druo.exists = 'S'
                }
                const emailData: any = {
                  actionStrategyPattern: 'EMAIL_CUPOS',
                  id: this.bnplService.personalInformation.id || localStorage.getItem('id') || "",
                };
                this.bnplService.emailPeticon(emailData).subscribe(res => {
                })
                this.bnplService.payment = resp;
                this.router.navigate(['await-alert', 'felicidades'])
              })
            } else {
              const emailData: any = {
                actionStrategyPattern: 'EMAIL_CUPOS',
                id: this.bnplService.personalInformation.id || localStorage.getItem('id') || "",
              };
              this.bnplService.emailPeticon(emailData).subscribe(res => {
              })
              this.bnplService.payment = resp;
              this.router.navigate(['await-alert', 'felicidades'])
            }

          } catch (error) {
          }

 try {
                if (this.bnplService.druo.exists != 'S') {
                  this.saveAccountDruo().subscribe((res: any) => {
                    if (res == "SUCCESS") {
                      this.bnplService.druo.exists = 'S'
                    }
                    this.bnplService.payment = resp;
                    this.router.navigate(['/payment'])
                  })
                } else {
                  this.bnplService.payment = resp;
                  this.router.navigate(['/payment'])
                }

              } catch (error) {
               
              }


       saveAccountDruo() {
    const dataSendDruo = {
      action: "CONNECT_ACCOUNT",
      id: this.bnplService.druo.id ? this.bnplService.druo.id : this.bnplService.druo.uuid,
      idInstitution: this.dataDruo.uuidBank,
      subType: this.dataDruo.subtype,
      accountNumber: this.dataDruo.numero,
      numberId: this.bnplService.stepsInformation.firstStep.numeroDocumento,
      change: this.dataDruo.change
    }
    return this.serviceDruo.saveDataDruo(dataSendDruo)
  }

    openDialogDruo() {
    if (!this.showDialog) {
      if (this.banksExperian) {
        const dialogRef = this.dialog.open(DialogDruo, {
          data: { banks: this.banksExperian, formData: this.dataDruo, listBanks: this.listBanks },
          width: '90%',
          height: '90%',
          maxWidth: '568px',
          maxHeight: '686px',
          panelClass: 'custom-dialog-container'

        });
        dialogRef.afterClosed().subscribe(result => {
          this.showDialog = false
          this.dataDruo = result
        });
      }
    }
  }

  getDataBanksDruo() {
    let dataPersonal = this.bnplService.personalInformation;
    let dataSteps = this.bnplService.stepsInformation;

    const data = {
      tipoDocumento: "1",
      totalIncoming: "0",
      fees: this.bnplService.personalInformation.feesApprobe,
      identification: "CC",
      primerApellido:
        dataPersonal.primerApellido !== '' ? dataPersonal.primerApellido : dataSteps.secondStep.primerApellido,
      numeroDocumento:
        dataPersonal.identificacion !== '' ? dataPersonal.identificacion : dataSteps.firstStep.numeroDocumento,
      value: this.bnplService.creditEmit.amountFinance,
      feesApprobe: null,
      action: "GET_DATA_EXPERIAN"
    };

    return this.serviceDruo.getDataExperian(data); // Devuelve el Observable
  }

 */
